import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { List } from "linqts";
import { Country } from "../../entity/Country";
import { Organization } from "../../entity/Organization";
import { Typology } from "../../entity/Typology";
import { AbstractCRUDService } from "./AbstractCRUDService";
import { TechnologyService } from "./TechnologyService";

@Injectable()
export class OrganizationService extends AbstractCRUDService<Organization, number> {

	private readonly technologyService: TechnologyService;

	private constructor(httpClient: HttpClient, technologyService: TechnologyService) {
		super(httpClient);
		this.technologyService = technologyService;
	}

	public async getAllAsync(): Promise<Organization[]> {
		return [
			{
				id: 1,
				name: "Eurecat",
				logo: "/assets/images/organizations/eurecat.png",
				description: "/assets/organization/eurecat/description.md",
				typology: [
					Typology.TECHNOLOGY_PROVIDER,
					Typology.TECHNOLOGY_USER,
				],
				contacts: [
					{
						name: "Aitor",
						email: "aitor.corchero@eurecat.org",
						position: "position",
						phone: "anyPhone",
					},
				],
				countries: [
					Country.EU,
				],
				technologies: [
					await this.technologyService.getByIdAsync(1),
					await this.technologyService.getByIdAsync(2),
					await this.technologyService.getByIdAsync(3),
					await this.technologyService.getByIdAsync(4),
					await this.technologyService.getByIdAsync(5),
				],
			},
		];
	}
	public async getByIdAsync(id: number): Promise<Organization> {
		const organizations = new List(await this.getAllAsync());
		return organizations.FirstOrDefault((value: Organization) => value.id === id);
	}

}



// WEBPACK FOOTER //
// ./Frontend/src/app/services/OrganizationService.ts